import { render } from "./BaseMenuMessage.vue?vue&type=template&id=2a12f7f6&scoped=true"
import script from "./BaseMenuMessage.vue?vue&type=script&lang=js"
export * from "./BaseMenuMessage.vue?vue&type=script&lang=js"

import "./BaseMenuMessage.vue?vue&type=style&index=0&id=2a12f7f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a12f7f6"]])

export default __exports__